import { render } from "./Recent_Photo_Carousel.vue?vue&type=template&id=ee3e63f4&scoped=true"
import script from "./Recent_Photo_Carousel.vue?vue&type=script&lang=js"
export * from "./Recent_Photo_Carousel.vue?vue&type=script&lang=js"

import "./Recent_Photo_Carousel.vue?vue&type=style&index=0&id=ee3e63f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3e63f4"]])

export default __exports__